/**
 * Check if the current viewport width is the provided value or bigger
 * Refer to BREAKPOINTS const in _js/base/consts.js
 * @param  {number}  breakpoint Value of the current breakpoint
 * @return {boolean} Whether the current viewport is equal or bigger to the provided breakpoint value
 */
const mediaFrom = (breakpoint = 0) => window.innerWidth >= breakpoint

export default mediaFrom
